// Module for the sidebar object

class Sidebar {
    constructor(id) {
        // Accept an onclick DOM element id to toggle the sidebar visibility
        this.visible = 0;
        this.showSidebar = this.showSidebar.bind(this);
        this.hideSidebar = this.hideSidebar.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        document.getElementById(id).onclick = this.toggleSidebar;
    }

    toggleSidebar() {
        if (this.visible === 0) {
            this.showSidebar();
            this.visible = 1;
        } else {
            this.hideSidebar();
            this.visible = 0;
        }
    }

    showSidebar() {
        const sidebar = document.getElementById('sidebar');
        const results = document.getElementById('results');
        const tabImage = document.getElementById('paper-plane');
        sidebar.style.transform = 'translateX(0px)';
        results.style.transform = 'translateX(150px)';
        tabImage.style.transform = 'scaleX(-1) translateX(-10px)';
    }
        
    hideSidebar() {
        const sidebar = document.getElementById('sidebar');
        const results = document.getElementById('results');
        const tabImage = document.getElementById('paper-plane');
        sidebar.style.transform = `translateX(-${window.global.constants.sidebarOffset}px)`;
        results.style.transform = 'translateX(0px)';
        tabImage.style.transform = 'scaleX(1)';
    }
}

export default Sidebar



// WEBPACK FOOTER //
// ./components/Sidebar.js